/*
  Mobile bottom nav (snippets/mobile-bottom-nav-Bar.liquid): slides out on scroll down and
  back in on scroll up by toggling body.mobile-nav-hidden. The sticky cart listens to the same
  class so it drops down into the nav's place.
*/
(function () {
  if (window.__mobileBottomNavInit) return;
  window.__mobileBottomNavInit = true;

  const HIDDEN_CLASS = 'mobile-nav-hidden';
  const SCROLL_DELTA = 10; // ignore tiny jitters
  const TOP_OFFSET = 60; // always show near the top of the page
  let lastScrollY = Math.max(window.scrollY, 0);
  let ticking = false;

  function update() {
    ticking = false;
    const currentScrollY = Math.max(window.scrollY, 0);
    const delta = currentScrollY - lastScrollY;

    // Don't fight scroll locks (cart drawer, menus) that freeze the page.
    if (document.body.classList.contains('overflow-hidden')) {
      lastScrollY = currentScrollY;
      return;
    }

    if (currentScrollY <= TOP_OFFSET) {
      document.body.classList.remove(HIDDEN_CLASS);
    } else if (Math.abs(delta) < SCROLL_DELTA) {
      return;
    } else {
      document.body.classList.toggle(HIDDEN_CLASS, delta > 0);
    }

    lastScrollY = currentScrollY;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
})();
